import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import JobList from './JobList';
import { useParams } from 'react-router-dom';
import { BASE_URI } from '../Config';
import AdminMhcAttentionJobList from './AdminMhcAttentionJobList';
import { Job } from './types';

const AdminUserView: React.FC = () => {
    const { userToken, userRole } = useAuth();
    const [jobs, setJobs] = useState<Job[]>([]);
    const [userEmail, setUserEmail] = useState<string | null>(null);
    const [userName, setUserName] = useState<string | null>(null);

    const { id } = useParams<{ id: string }>();

    const getUserInfo = async () => {
        try {
            const response = await fetch(`${BASE_URI}/user_info/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`
                }
            });

            const data = await response.json();

            if (data.user) {
                console.log(data.user);
                setUserEmail(data.user.email);
                setUserName(data.user.name);
                // Redirect or perform other actions after successful signup
            }
            else {
                console.log("Retrieving user failed!");
            }
        } catch (error) {
            console.error("There was an error retrieving user role:", error);
        }
    };

    useEffect(() => {
        getUserInfo();
    }, [userToken])


    if (userRole != "Admin") {
        return <div id="content-pane">
                <h3>Not authorized.</h3>
            </div>;
    }

    return (
        <div>
            <div id="content-pane">
                <div className='user_info'>
                    {userName && <h3>{userName}</h3>}
                    {userEmail && <p>{userEmail}</p>}
                </div>
                {id && (
                    <>
                        <JobList
                            jobs={jobs}
                            setJobs={setJobs}
                            userId={id}
                            title="TAPIR Jobs"
                            emptyMessage="No TAPIR jobs have been submitted yet."
                        />
                        <AdminMhcAttentionJobList userId={id} />
                    </>
                )}
            </div>
        </div>
    );
}

export default AdminUserView;
